import { Pipe, PipeTransform } from '@angular/core';

const TYPES = {
    1: 'MOBILE',
    2: 'ESPECIAL',
    3: 'TRADICIONAL'
}

@Pipe({
  name: 'toDate'
})
export class ToSurvey implements PipeTransform {

  transform(value: any): any {

    return TYPES[value];
  }

}
